import service from '../request/golbal'

var token = sessionStorage.getItem("token");

//查询首页banner图
export function applyCompany(data) {
  return service.post(`/front/save/applyCompany`, data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}

export function checkCompany(data) {
  return service.post(`/front/findbyCondition/company`, data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}

export function drugList(data) {
  return service.get(`/front/drugList/${data}`, {
    headers: {
      'content-type': 'application/json'
    }
  })
}

//存草稿
export function batchSave(data) {
  return service.post(`/front/batchSave/drug`, data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}


//删除草稿
export function deletedrug(data) {
  return service.get(`/front/delete/drug/${data}`, {
    headers: {
      'content-type': 'application/json'
    }
  })
}

//保存
export function submit(data) {
  return service.post(`/front/batchSave/drug`, data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}



//登录
export function login(data) {
  return service.post(`/sys/login`, data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}


//获取公司


export function tbapplycompany(data,token) {
  return service.post(`/adm/tbapplycompany/list`, data, {
    headers: {
      'content-type': 'application/json',
      'token': token
    }
  })
}

//审批时间
export function approve(data,token) {

  return service.post(`/adm/tbapplycompany/approve/company`, data, {
    headers: {
      'content-type': 'application/json',
      'token': token
    }
  })
}



//获取提交list
export function postDrugList(data) {
  return service.get(`/front/postDrugList/${data}`, {
    headers: {
      'content-type': 'application/json',

    }
  })
}

//获取公司列表

export function dictItem(data) {
  return service.post(`/sys/dictItem/list`,data, {
    headers: {
      'content-type': 'application/json',

    }
  })
}



// WEBPACK FOOTER //
// ./src/request/api.js